module.exports = __webpack_public_path__ + "static/img/img_0430.8cb932e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0430.jpg
// module id = SxU6
// module chunks = 0